var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Chevrons / Right - Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20211011_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0-Coverage-/-1.0-Pass-/-1.4-Quote",
    transform: "translate(-215.000000, -1487.000000)",
    stroke: "#FF0008",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "PA",
    transform: "translate(185.000000, 1404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Know-More",
    transform: "translate(30.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.500000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Chevrons-/-Right---Blue",
    transform: "translate(4.500000, 7.000000) rotate(90.000000) translate(-4.500000, -7.000000) "
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    points: "1.05793939 1 7 7.08284315 1 13"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownRed);
export default __webpack_public_path__ + "static/media/chevron-down-red.35cc410c9fc90d51779777719cf2fe27.svg";
export { ForwardRef as ReactComponent };